/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum VoucherStatus {
  ACTIVE = 'active',
  PENDING_PAYMENT = 'pending_payment',
  USED = 'used',
  ARCHIVED = 'archived',
}
